import { useState } from "react";
import {
  addDays,
  addMonths,
  endOfMonth,
  startOfMonth,
  subDays,
  subMonths,
} from "date-fns";
import { PostsDetailsContextProvider } from "@circle-react/contexts/postsDetailsContext";
import { Loader } from "@circle-react-uikit/Loader";
import { useAllEvents } from "../hooks/useAllEvents";
import { EventsCalendar } from "./EventsCalendar";

export const CalendarView = () => {
  const initialDate = subDays(startOfMonth(new Date()), 7);
  const [currentDate, setCurrentDate] = useState(initialDate);
  const endDate = addDays(addMonths(endOfMonth(currentDate), 2), 7);

  const { events, isLoading, perPageEventIds, onEventChange, onEventDestroy } =
    useAllEvents({
      params: {
        past_events: false,
        filter_date: {
          start_date: currentDate.toDateString(),
          end_date: endDate.toDateString(),
        },
        calendar_view: true,
      },
      isCalendarView: true,
    });

  const fetchNextPage = () => {
    setCurrentDate(addMonths(currentDate, 1));
  };

  const fetchPrevPage = () => {
    setCurrentDate(subMonths(currentDate, 1));
  };

  if (events.length == 0 && isLoading) {
    return <Loader />;
  }

  return (
    <PostsDetailsContextProvider perPagePostIds={perPageEventIds}>
      <EventsCalendar
        events={events}
        onChange={onEventChange}
        onDestroy={onEventDestroy}
        fetchNextPage={fetchNextPage}
        fetchPrevPage={fetchPrevPage}
      />
    </PostsDetailsContextProvider>
  );
};
